<template>
  <a-space>
    <a-button v-show="!stampShowed" type="primary" :disabled="disabled" @click="sign('1')">统一CA签章</a-button>
    <a-button v-show="!stampShowed" type="primary" :disabled="disabled" @click="sign('2')">福建省企业电子签章</a-button>
  </a-space>
</template>

<script>

export default {
  name: 'SignatureButton',
  components: { },
  data() {
    return {
    }
  },
  props: ['disabled','stampShowed'],
  mounted() {},
  created() {},
  methods: {
    /**
     * 签章调用
     * @param type 签章类型
     */
    sign(type) {
      try {
        if (this.$parent.$parent.$refs.table.columns.some(item => item.dataIndex === "isChecked" || item.title === "投标人确认")) {
          if(this.$parent.$parent.$refs.table.dataSource.some(item => item.isChecked !== "-2" && item.isChecked !== "1")) {
            this.$message.error('当前页面尚有投标人未确认，如已全部确认或超过确认时间，请刷新页面后进行签章！');
            return;
          }
        }
      } catch (e) {

      }
      this.$emit("sign", type);
    },
  }
}
</script>

<style scoped>

</style>